export class FrontendFieldError {
    //netgen start
    fieldId: string;
    message: string;
    warning = false;
    subItem: string;
    //netgen end

    constructor(fieldId: string, message: string, warning = false, subItem: string = null) {
        this.fieldId = fieldId;
        this.message = message;
        this.warning = warning;
        this.subItem = subItem;
    }
}
